import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { seasideConfig } from "./data";

export default function SeasidePage() {
  return <OregonCityPageTemplate config={seasideConfig} />;
}